<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">日程和提醒</a></li>
                <li><a href="#">记事待办/备忘录</a></li>
            </ul>
        </div>

        <div class="formbody">
            <div id="usual1" class="usual"> 
                <div class="itab">
                    <ul> 
                    <li><a href="#tab1" @click="pageChange(1,0,'')" :class="{selected:list[0].isSelected}">全部待办事项</a></li> 
                    <li><a href="#tab2" @click="pageChange(1,1,'1')" :class="{selected:list[1].isSelected}">今天待办事项</a></li> 
                    <li><a href="#tab3" @click="pageChange(1,2,'2')" :class="{selected:list[2].isSelected}">明天待办事项</a></li> 
                    <li><a href="#tab4" @click="pageChange(1,3,'3')" :class="{selected:list[3].isSelected}">最近7天待办事项</a></li> 
                    <li><a href="#tab5" @click="pageChange(1,4,'4')" :class="{selected:list[4].isSelected}">最近一个月待办事项</a></li> 
                    <li><a href="#tab6" @click="pageChange(1,5,'6')" :class="{selected:list[5].isSelected}">已完成的待办事项 </a></li> 
                    <li><a href="#tab7" @click="pageChange(1,6,'7')" :class="{selected:list[6].isSelected}">回收站</a></li> 
                    </ul>
                </div> 

                <div id="tab1" class="tabson">    
                    <div class="tools">
                        <ul class="toolbars">
                        <li class="click" @click="memorandumadd()">新增待办</li>
                        <li @click="delDaiBan()">删除</li>
                        <li @click="compDelDaiBan()">彻底删除</li>
                        </ul>                    
                    </div>                    
                        <table class="tablelist">
                        <thead>
                        <tr>
                            <th><input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/> </th>
                            <th>标题</th>
                            <th>优先级</th>
                            <th>完成度</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in daibanList" :class="{odd:index%2!=0}">
                            <td width="3%"><input name="dbCheck" id="dbCheck" type="checkbox" :value="item.id" /></td>
                            <td width="60%"><a href="#" @click="gotodetail(item.id)">{{item.dbtitle}}</a></td>   
                            <td width="10%">
                                <span v-if="item.prority==1">最低</span>
                                <span v-else-if="item.prority==2">低</span>
                                <span v-else-if="item.prority==3">普通</span>
                                <span v-else-if="item.prority==4">高</span>
                                <span v-else-if="item.prority==5">最高</span>
                            </td>
                            <td width="30%">{{item.degree}}%</td> 
                        </tr>                                        
                        </tbody>
                    </table>
                    
                
                    <div class="pagin">
                        <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="pageIndex"
                                    :page-sizes="[50]"
                                    :page-size="50"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="totalCount">
                                </el-pagination>
                    </div>
                    
                    <!-- 查询等待 -->
                    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                        top: 0; left: 0;display: block;" v-show="loadingShow"></div>
                    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                        -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                        <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                        <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
                    </div>

                </div> 
                <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                    <b>注意</b>
                </div>
                <ul class="infolist">
                    <li><span>以下你经常忘记吗？</span></li>
                    <li><span>好记性不如烂笔头</span></li>
                    <li><span>云验证打造智能提醒，超越烂笔头!</span></li>
                    <li><span>生日、纪念日、起床闹钟、定期问候、工作任务、还款还贷还物、收款收件收信、定期服药、差旅赶点、聚会约会</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            list:[
                {isSelected:true,isShow:true,index:1},
                {isSelected:false,isShow:false,index:2},
                {isSelected:false,isShow:false,index:3},
                {isSelected:false,isShow:false,index:4},
                {isSelected:false,isShow:false,index:5},
                {isSelected:false,isShow:false,index:6},
                {isSelected:false,isShow:false,index:7},
            ],
            pageIndex:0,
            totalCount:0,
            daibanList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1,0,'');
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val,0,'')
        },
        handleCurrentChange(val) {
            this.pageChange(val,0,'')
        },
        pageChange(pageIndex, index, flag){
            this.list.forEach(function(obj){
                obj.isSelected = false;
            });
            this.list[index].isSelected = true;
            this.loadingShow = true;
            var that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50, 'account':'','flag':flag}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/daiban.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.daibanList = res.data.daibanList;
                    that.pageIndex = parseInt(pageIndex);
                    that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                    that.currentPage = pageIndex;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        memorandumadd(){
            location.href = "/memorandumadd";
        },
        delDaiBan(){
            var ids = '';
            var checkers = document.getElementsByName('dbCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(ids =='')
                        ids = checkers[i].value;
                    else
                        ids = ids + ',' + checkers[i].value;
                }
            }
            if(ids == ''){
                alert("请选选择要删除的项！");
                return;
            }
            var that = this;
            let data = {'ids':ids}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/deldaiban.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.pageChange(1,0,'')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
            this.cancelChecke();
        },
        compDelDaiBan(){
            var ids = '';
            var checkers = document.getElementsByName('dbCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(ids =='')
                        ids = checkers[i].value;
                    else
                        ids = ids + ',' + checkers[i].value;
                }
            }
            if(ids == ''){
                alert("请选选择要彻底删除的项！");
                return;
            }
            var that = this;
            let data = {'ids':ids}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/compdeldaiban.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.pageChange(1,0,'')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
            this.cancelChecke();
        },
        changAllCheck(){
            var checkers = document.getElementsByName('dbCheck');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        cancelChecke(){
            var checkers = document.getElementsByName('dbCheck');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    checkers[i].checked = false;
                }
            }
        },
        gotodetail(id){
            location.href = "/memorandumedit?id=" + id;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/kingtime/memorandum.vue